import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTuinaTherapistScheduleGrouped } from '@/service/tuina'

export const fetchTuinaTherapistScheduleGrouped = createAsyncThunk(
  'tuinaTherapistScheduleGrouped/fetchTuinaTherapistScheduleGrouped',
  async ({ query = {} } = {}, { rejectWithValue }) => {
    try {
      const response = await getTuinaTherapistScheduleGrouped(query)
      const rows = Array.isArray(response.data) ? response.data : []
      return {
        data: rows.filter((row) => row.status === 'on_duty'),
        query
      }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.msg ||
          error?.message ||
          '加载排班失败'
      )
    }
  }
)

const therapistScheduleGroupedSlice = createSlice({
  name: 'tuinaTherapistScheduleGrouped',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTuinaTherapistScheduleGrouped.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(fetchTuinaTherapistScheduleGrouped.fulfilled, (state, action) => {
        state.fetching = false
        state.error = null
        state.query = action.payload.query
        state.data = action.payload.data || []
      })
      .addCase(fetchTuinaTherapistScheduleGrouped.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload ?? action.error?.message ?? null
      })
  }
})

export default therapistScheduleGroupedSlice.reducer
